import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "VarietiesSearch" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "queryResults" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "history" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "历史搜索", -1)
const _hoisted_7 = { class: "list" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanPopup, {
      class: "searchDialog",
      show: $props.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($props.show) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_VanSearch, {
            placeholder: "请输入关键字",
            modelValue: $setup.getListData.name,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (($setup.getListData.name) = $event)),
              $setup.searchVariety
            ],
            "show-action": "",
            shape: "round"
          }, {
            action: _withCtx(() => [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {$setup.emit("update:show",false);$setup.getListData.name = ""})
              }, "取消")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_VanList, {
            class: "queryResultsWarpper",
            loading: $setup.loading,
            "immediate-check": false,
            finished: $setup.finished,
            onLoad: $setup.page
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "queryResultsItem",
                  key: `queryResultsItem${idx}`,
                  onClick: ($event: any) => ($setup.searchList(item))
                }, _toDisplayString(item.name), 9, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ], 512), [
          [_vShow, $setup.categories.length != 0 && $setup.getListData.keyword != ""]
        ]),
        _withDirectives(_createElementVNode("div", { class: "noData" }, "没有找到“" + _toDisplayString($setup.getListData.name) + "”品种", 513), [
          [_vShow, $setup.categories.length == 0 && $setup.getListData.name != "" && !$setup.loading]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.history, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx,
                onClick: ($event: any) => ($setup.searchList(item))
              }, _toDisplayString(item.name), 9, _hoisted_8))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}